function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import StyledH1 from './H1.style';
import { getCleanProps } from '../../../../utility/getCleanProps';
H1.propTypes = {
  /** the variant of h1 to show  */
  variant: PropTypes.oneOf(['light', 'impact']),

  /** use responsive styling consistent with NAB's native mobile apps */
  shouldResize: PropTypes.bool,

  /** renders the right color on a dark background */
  isOnDarkBg: PropTypes.bool,

  /** reference to this H1 element */
  textRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),

  /** the H1 content */
  children: PropTypes.node.isRequired
};
H1.defaultProps = {
  variant: 'light',
  shouldResize: false,
  isOnDarkBg: false
};
export function H1(_ref) {
  var children = _ref.children,
      textRef = _ref.textRef,
      restProps = _objectWithoutProperties(_ref, ["children", "textRef"]);

  return /*#__PURE__*/React.createElement(StyledH1, _extends({}, getCleanProps(restProps), {
    ref: textRef
  }), children);
}